export default __webpack_public_path__ + "static/media/circle-info-grey.0909cdc6.svg";